import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { useStore } from '../../store';
import { IServerErrorResponse } from '../../types';
import { IBillItem } from '../../pages/BillPay/types';

interface IProps {
    billId: string,
    paymentReminderEnabled: boolean
}

export const useSetBillReminder = (onSuccess: (billItem: IBillItem) => void, onError: (data: IServerErrorResponse) => void) => {
  const { getPersonalAccount, user: { customerId } } = useStore(state => state);
  const { accountExternalId } = getPersonalAccount();

  return useMutation(
    async (props : IProps) => {
      const { data } = await httpService.put(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/${props.billId}/paymentRemainder`, { paymentReminderEnabled: props.paymentReminderEnabled });
      return data;
    },
    {
      onSuccess: (billItem: IBillItem) => {
        onSuccess(billItem);
      },
      onError: (error: IServerErrorResponse) => {
        onError(error);
      },
    },
  );
};
